import React from "react";

import {
  XYPlot,
  XAxis,
  YAxis,
  VerticalGridLines,
  HorizontalGridLines,
  MarkSeries,
  Hint,
  makeVisFlexible
} from "react-vis";
import moment from "moment";
const colorRanges = {
  typeA: [, "#0D676C"],
  typeB: ["#59E4EC", "#B52F93"]
};

const Flexible = makeVisFlexible(XYPlot);
const trimSet = arr => {
  if (arr.length < 10) return arr;
  const seen = [];
  return arr.filter(function(v) {
    const m = moment(v).format("MM");
    const y = moment(v).format("YY");
    if (seen.includes(m + y)) return false;
    else {
      seen.push(m + y);
      return true;
    }
  });
};
export default class Guitar extends React.Component {
  state = {
    value: false
  };
  render() {
    const { data, labels } = this.props.formatter(this.props.data);
    const colorType = "typeB";
    const WORDS = labels;
    const maxWord = Math.max(...WORDS.map(w => w.length));
    if (data.length === 2) {
      return <></>;
    }
    const markSeriesProps = {
      animation: true,
      className: "mark-series-example",
      sizeRange: [this.props.eq?15:3, 30],
      seriesId: "my-example-scatterplot",
      colorRange: colorRanges[colorType],
      opacityType: "literal",
      data,
      onNearestXY: value => this.setState({ value })
    };
    return (
      <div className="canvas-wrapper">
        <Flexible
          onMouseLeave={() => this.setState({ value: false })}
          xType="time"
          height={200}
          margin={{ right: 50, left: Math.sqrt(maxWord) * 50 }}
        >
          {/* <VerticalGridLines /> */}
          <HorizontalGridLines />
          <XAxis
            tickFormat={v => moment(v).format("MMM DD")}
            tickValues={trimSet(data.map(d => d.x))}
          />
          <YAxis hideLine left={-30} tickFormat={v => WORDS[v]} />
          <MarkSeries {...markSeriesProps} />
          {this.state.value ? (
            <Hint value={this.state.value}>
              <div className="label-wrapper">
                <div className="label-title">
                  {moment(this.state.value.x).format("DD MMM, YYYY")}
                </div>
                <div className="label-value">{this.state.value.size}</div>
              </div>
            </Hint>
          ) : null}
        </Flexible>
      </div>
    );
  }
}
